'use strict'

export const copyShare = (() => {
    const init = () => {
        const dataTaskShareButtons = document.querySelectorAll('[data-task-share]')
        
        dataTaskShareButtons.forEach(button => {
            button.addEventListener('click', () => {
                const textToCopy = button.dataset.taskShare;

                navigator.clipboard.writeText(textToCopy).then(() => {
                  button.innerHTML = 'Gekopieerd naar klembord!'

                  setTimeout(() => {
                    button.innerHTML = 'Link kopieren'
                  }, 2000)
                })
            })
        })
    }

    return {
        init
    }
})()